import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ApplicationServices() {
    return (
        <main className="relative overflow-hidden bg-gradient-to-b from-slate-900 to-black text-gray-100 py-16">
            <section className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center gap-12">
                {/* Text Section */}
                <div className="flex-1 z-10">
                    <h1 className="text-4xl font-bold text-white">
                        Application Services
                    </h1>
                    <p className="mt-4 text-lg text-gray-300 leading-relaxed">
                        SecureID Technologies delivers enterprise-grade application design,
                        modernization, and integration services to help agencies and
                        businesses streamline operations. Our team builds scalable, secure,
                        and compliant systems that integrate seamlessly with your existing
                        identity and HR infrastructure.
                    </p>

                    <h2 className="mt-8 text-2xl font-semibold text-white">Core Capabilities</h2>
                    <ul className="mt-3 list-disc pl-6 text-gray-300 space-y-2">
                        <li>Custom .NET and React application development</li>
                        <li>System integration and API automation</li>
                        <li>Azure and Supabase cloud deployment</li>
                        <li>Data migration and security compliance</li>
                    </ul>

                    <p className="mt-8 text-gray-300">
                        Whether you're building a new platform or enhancing existing
                        solutions, SecureID’s development team ensures every product meets
                        your performance, accessibility, and compliance goals.
                    </p>

                    <p className="mt-10 text-center lg:text-left text-sm text-gray-400">
                        <Link to="/" className="text-indigo-400 hover:underline">
                            ← Back to Home
                        </Link>
                    </p>
                </div>

                {/* Animated Image */}
                <motion.div
                    className="flex-1 flex justify-center"
                    initial={{ opacity: 0, x: 200 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                >
                    <img
                        src="/Images/application-services.jpg"
                        alt="Application Services illustration"
                        className="w-[90%] max-w-md rounded-2xl shadow-2xl"
                    />
                </motion.div>
            </section>
        </main>
    );
}
